import { __assign, __generator } from "tslib";
import { put, takeLatest, call, select } from 'redux-saga/effects';
import objValues from 'lodash/values';
import { mentionSearchChange, initOnPageUsers, populateFriends, } from './actionCreators';
import { hasUsersOnPage, getFriendsPage, getUsersOnPage, getServerFriends, } from './selectors';
import { request } from '../../../xhr';
export function fakeResponse(options) {
    if (process.env.NODE_ENV !== 'production') {
        // eslint-disable-next-line
        var users = require('@wix/da-sample-data').users;
        var filtered = users.filter(function (v) { return v.username[0] === options.params.letter; });
        var friends = {};
        for (var _i = 0, filtered_1 = filtered; _i < filtered_1.length; _i++) {
            var i = filtered_1[_i];
            friends[i.username] = i;
        }
        return {
            alpha: options.params.letter,
            page: options.params.page,
            users: friends,
        };
    }
}
function fetchUsersOnPage() {
    var onPage, links, _i, links_1, link, username, usericon, userId, userUuid, type;
    return __generator(this, function (_a) {
        onPage = {};
        links = Array.from(document.getElementsByClassName('user-link'));
        for (_i = 0, links_1 = links; _i < links_1.length; _i++) {
            link = links_1[_i];
            username = link.getAttribute('data-username');
            usericon = link.getAttribute('data-icon');
            userId = link.getAttribute('data-userid');
            userUuid = link.getAttribute('data-useruuid');
            type = link.getAttribute('data-usertype');
            // TODO: use isGroup util function
            if (!username ||
                !usericon ||
                !type ||
                !userId ||
                !userUuid ||
                type === 'group') {
                continue;
            }
            // We had a bug that generated broken mention links, have to exclude them
            if (!/^\d+$/.test(userId)) {
                continue;
            }
            if (!/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(userUuid)) {
                continue;
            }
            onPage[username] = {
                username: username,
                usericon: usericon,
                type: type,
                userId: userId,
                userUuid: userUuid,
            };
        }
        return [2 /*return*/, onPage];
    });
}
function fetchFriendsForLetter(alpha, page, search) {
    var params, result;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                params = {
                    search: search,
                    letter: alpha,
                    page: page,
                    user_type: 'both',
                };
                return [4 /*yield*/, call(request, {
                        method: 'get',
                        url: "/user/friendsforletter",
                        params: params,
                    }, fakeResponse)];
            case 1:
                result = _a.sent();
                return [2 /*return*/, result];
        }
    });
}
export function doSearchChange(action) {
    var hasUsers, foundUsers, _a, value, setMentions, firstLetter, searched, page, friends, regexp, onPage, onServer, stored, suggestions;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, select(hasUsersOnPage)];
            case 1:
                hasUsers = _b.sent();
                if (!!hasUsers) return [3 /*break*/, 4];
                return [4 /*yield*/, call(fetchUsersOnPage)];
            case 2:
                foundUsers = _b.sent();
                return [4 /*yield*/, put(initOnPageUsers(foundUsers))];
            case 3:
                _b.sent();
                _b.label = 4;
            case 4:
                _a = action.payload, value = _a.value, setMentions = _a.setMentions;
                firstLetter = value[0];
                searched = {
                    name: value,
                    avatar: 'https://a.deviantart.net/avatars/default.gif',
                };
                setMentions([searched]);
                if (!(value !== '' && firstLetter !== '' && firstLetter !== '@')) return [3 /*break*/, 8];
                return [4 /*yield*/, select(getFriendsPage, firstLetter)];
            case 5:
                page = _b.sent();
                return [4 /*yield*/, call(fetchFriendsForLetter, firstLetter, page, value)];
            case 6:
                friends = _b.sent();
                if (!!friends.error) return [3 /*break*/, 8];
                return [4 /*yield*/, put(populateFriends(firstLetter, friends.users, friends.nextOffset))];
            case 7:
                _b.sent();
                _b.label = 8;
            case 8:
                if (!value || value === '') {
                    return [2 /*return*/, setMentions([])];
                }
                regexp = new RegExp("^".concat(value), 'i');
                return [4 /*yield*/, select(getUsersOnPage)];
            case 9:
                onPage = _b.sent();
                return [4 /*yield*/, select(getServerFriends, firstLetter)];
            case 10:
                onServer = _b.sent();
                stored = objValues(__assign(__assign({}, onPage), onServer));
                suggestions = stored
                    .filter(function (v) { return v.username.match(regexp); })
                    .map(function (v) { return ({
                    name: v.username,
                    avatar: v.usericon,
                    type: v.type,
                    userId: v.userId,
                    userUuid: v.userUuid,
                }); })
                    .filter(function (user, idx, self) { return idx === self.findIndex(function (t) { return t.name === user.name; }); })
                    .sort(function (a, b) {
                    if (a.name === value) {
                        return 1;
                    }
                    if (b.name === value) {
                        return -1;
                    }
                    if (a.name < b.name) {
                        return -1;
                    }
                    if (a.name > b.name) {
                        return 1;
                    }
                    return 0;
                });
                setMentions(suggestions);
                return [2 /*return*/];
        }
    });
}
export default function saga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, takeLatest(mentionSearchChange, doSearchChange)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
//# sourceMappingURL=saga.js.map